import { render, staticRenderFns } from "./Scribe.vue?vue&type=template&id=253b54c2&scoped=true&"
import script from "./Scribe.vue?vue&type=script&lang=js&"
export * from "./Scribe.vue?vue&type=script&lang=js&"
import style0 from "./Scribe.vue?vue&type=style&index=0&id=253b54c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253b54c2",
  null
  
)

export default component.exports